export const colors = {
  primary: '#008256',
  secondary: '#608e63',
};

export const colorsList = [
  '#517753',
  '#A89E59',
  '#CED173',
  '#A8B38B',
  '#608E63',
  '#839E9D',
  '#168FEB',
  '#25618F',
  '#333333',
  '#464646',
];

export const PolygonBaseColor = {
  ABLINE: '#FF0000',
  FIELD: '#3ED848',
  SUBUNIT: '#FFFF00',
  STABLE: '#FF0000',
};

export const insectPhaseColor = {
  '100_1': '#5CB85C',
  '100_2': '#F0AD4E',
  '100_3': '#168FEB',
  '100_4': '#D9534F',
  '100_5': '#A6B355',
  '100_6': '#39A4A4',
  '100_7': '#9B8656',
  '100_8': '#839E9D',
  '100_9': '#E5804F',
  '100_10': '#78719D',
  '100_11': '#70AC7D',
  '100_12': '#6A957D',
  '100_13': '#8F927A',

  '111_1': '#5CB85C',
  '111_2': '#F0AD4E',
  '111_3': '#168FEB',

  '114_1': '#5CB85C',
  '114_2': '#F0AD4E',
  '114_3': '#168FEB',
  '114_4': '#D9534F',

  '108_1': '#5CB85C',
  '108_2': '#F0AD4E',

  '104_1': '#5CB85C',
  '104_2': '#F0AD4E',
  '104_3': '#168FEB',
  '104_4': '#D9534F',
  '104_5': '#A6B355',
  '104_6': '#39A4A4',
  '104_7': '#9B8656',
  '104_8': '#839E9D',
  '104_9': '#E5804F',
  '104_10': '#78719D',
  '104_11': '#70AC7D',
  '104_12': '#6A957D',
  '104_13': '#8F927A',
  '104_14': '#B48F76',
  '104_15': '#AF7976',

  '103_1': '#5CB85C',
  '103_2': '#F0AD4E',
  '103_3': '#168FEB',
  '103_4': '#D9534F',
  '103_5': '#A6B355',
  '103_6': '#39A4A4',
  '103_7': '#9B8656',
  '103_8': '#839E9D',
  '103_9': '#E5804F',
  '103_10': '#78719D',
  '103_11': '#70AC7D',
  '103_12': '#6A957D',
  '103_13': '#8F927A',
  '103_14': '#B48F76',
  '103_15': '#AF7976',
  '103_16': '#A19D56',
  '103_17': '#95A979',
  '103_18': '#C69A52',
  '103_19': '#8F9279',
  '103_20': '#5EA1A1',
  '103_21': '#8F927A',
  '103_22': '#598BA1',
  '103_23': '#B48F76',
  '103_24': '#7E889D',

  '109_1': '#5CB85C',
  '109_2': '#F0AD4E',
  '109_3': '#168FEB',
  '109_4': '#D9534F',
  '109_5': '#A6B355',

  '115_1': '#5CB85C',
  '115_2': '#F0AD4E',

  '117_1': '#5CB85C',
  '117_2': '#F0AD4E',
  '117_3': '#168FEB',
  '117_4': '#D9534F',

  '113_1': '#5CB85C',
  '113_2': '#F0AD4E',
  '113_3': '#168FEB',
  '113_4': '#D9534F',
};

export const analisysColor = ['#168FEB', '#50abf0', '#517753'];

export const checksTypeColor = {
  total: '#929292',
  defending: '#77AD90',
  feeding: '#813A4C',
  container: '#CEDB8C',
  irrigating: '#608CC9',
  generic: '#46155C',
};

export const checksStatusColor = ['#DCDCDC', '#FFBB54', '#D9534F'];

export const checksPhytoCategoryColor = {
  dose: '#D3D8D2',
  adversity: '#955135',
  active_substance: '#CAA89A',
  max_treatment: '#E195A7',
  treatment_break: '#F7D7A6',
  barrel_water: '#4A7992',
  product_revocated: '#9AAC97',
  over_last_use: '#AC9D34',
  preharvesting: '#C09CA5',
  max_treatment_disciplinary: '#969699',
  active_substance_crop_disciplinary: '#52AD6D',
  max_treatment_substance_disciplinary: '#AFC5E4',
  over_last_use_disciplinary: '#E9E7E4',
  active_substance_concentration_disciplinary: '#A28AAD',
  dose_threshold_disciplinary: '#E9948A',
  max_treatment_molecule_disciplinary: '#46155C',
  bio_product: '#D0E558',
  dose_threshold_cu: '#D5CE99',
  license: '#E88D2B',
};

export const tabAnalisysColor = [
  '#813A4C',
  '#46155C',
  '#4A7992',
  '#608CC9',
  '#E27063',
  '#77AD90',
  '#CEDB8C',
  '#EEAE4E',
];

export const stableTabProduction = ['#056dbb', '#99cef6'];

export const stableTabProductionApproved = ['#056dbb', '#50abf0', '#99cef6'];

export const dashboardProductionApproved = ['#608e63', '#50abf0'];
